 <div class="cookie-banner" *ngIf="!cookiesAccepted">
    <div class="cookie-text">
      <!-- <div class="cookie-title">We value your privacy!</div> -->
      <div class="cookie-description">
        We use cookies to enhance your experience, analyze site usage, and improve our services. By clicking "Accept all ", you agree to the use of cookies as described in our
        <a target="_blank" [href]="origin+'/cookie-policy'">Cookie Policy</a> & <a target="_blank" [href]="origin+'/privacy-policy'">Privacy Policy</a>.
      </div>
    </div>
    <div class="cookie-buttons">
      <button class="btn-outline" (click)="openCookieSettingModal()" style="min-width: 182px;">Cookie settings</button>
      <!-- <button class="btn-outline">Reject All</button> -->
      <button class="btn-filled" (click)="acceptAllCookie()" style="min-width: 138px;">Accept All</button>
    </div>
  </div>